export default "__VITE_ASSET__BRsKZl42__"